var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-hcaptcha',{ref:"captcha",attrs:{"sitekey":"2c0a8df8-37dd-4192-aee2-d4af924f298b"},on:{"verify":_vm.onVerify}}),_vm._v(" "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return (() => _vm.reload()).apply(null, arguments)}}},[_vm._v("Reload Captcha")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }